import { render, staticRenderFns } from "./SmartButton.vue?vue&type=template&id=21902bfc&scoped=true&"
import script from "./SmartButton.vue?vue&type=script&lang=js&"
export * from "./SmartButton.vue?vue&type=script&lang=js&"
import style0 from "./SmartButton.vue?vue&type=style&index=0&id=21902bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21902bfc",
  null
  
)

export default component.exports